import { render, staticRenderFns } from "./OnlyHorizontalScreen.vue?vue&type=template&id=5c7fcff1"
import script from "./OnlyHorizontalScreen.vue?vue&type=script&lang=js"
export * from "./OnlyHorizontalScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports